import { styled } from '@this/constants/themes';
import React from 'react';
import { css } from 'styled-components';

interface Props {
  active: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const HamburgerButton: React.FC<Props> = ({ active, onClick }) => {
  return (
    <ButtonContainer active={active} onClick={onClick}>
      <span />
      <span />
      <span />
    </ButtonContainer>
  );
};

const ButtonContainer = styled.button<{ active: boolean }>`
  position: relative;
  width: 20px;
  height: 19px;
  background-color: transparent;
  padding: 0;
  outline: none;

  &:hover,
  &:focus {
    background-color: transparent;
  }

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${props => props.theme.accentColor};
    border-radius: 4px;
    transition: opacity 0.3s, transform 0.3s;

    &:nth-of-type(1) {
      top: 0;

      ${({ active }) =>
        active &&
        css`
          transform: translateY(8px) rotate(-45deg);
        `}
    }
    &:nth-of-type(2) {
      top: 8px;

      ${({ active }) =>
        active &&
        css`
          opacity: 0;
        `}
    }
    &:nth-of-type(3) {
      bottom: 0;

      ${({ active }) =>
        active &&
        css`
          transform: translateY(-8px) rotate(45deg);
        `}
    }
  }
`;

export default HamburgerButton;
